<template>
  <div class="second_navbar_container">
    <el-menu
      :default-active="activeIndex"
      class="el_menu_demo"
      mode="horizontal"
      background-color="#fff"
      :text-color="navBackground"
      :active-text-color="activeTextColor"
    >
        <template v-for="(router, index) in routes" >
          <el-menu-item :key="index" :index="router.meta.title" @click="handleSelect(router.path)">{{ router.meta.title}}</el-menu-item>
        </template>
        </el-menu>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        navBackground:'#000',
        activeTextColor: "#0555b6",
        lastScrollTop: 0,
        fixedBoxTop: '0',
      }
    },
    computed: {
      // 获取当前路由信息
      /*
      * 1. 获取父级路由会出现为空的情况：this.$route.matched[0] = undefined
      * 2. 获取全局路由，该方法为内部属性，会因为版本不同不可用：this.$router.option.routes
      * 3. 子路由不存在导致返回错误：
      *  */
      routes() {
        const parentRoute = this.$route.matched[0];
        if (!parentRoute) {
          console.warn('未匹配到父级路由');
          return [];
        }
        const parentPath = parentRoute.path;
        const routes = this.$router.options.routes;
        for (const route of routes) {
          if (route.path === parentPath) {
            return (route.children || []).filter(child => !child.hidden);
          }
        }
        return []; // 如果没有找到匹配的路由，返回空数组
      },
      // 获取当前路由所在位置
      activeIndex() {
        return this.$router.currentRoute.meta.title;
      }
    },
    methods: {
      handleSelect(key) {
        // 构建绝对路径，避免在详情页面时相对路径拼接错误
        const parentPath = this.$route.matched[0]?.path || '';
        const absolutePath = parentPath + '/' + key;
        this.$router.push(absolutePath).catch( () => {} )
        console.log(this.activeIndex)
      },
    }
  }
</script>

<style scoped>
  .el_menu_demo{
    border: none !important;
  }
</style>
